import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageMeta, getPageMeta } from "@/lib/pageMeta";

const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = getPageMeta(pathname);
    applyPageMeta(meta);
  }, [pathname]);

  return null;
};

export default PageMeta;
